module.exports = __webpack_public_path__ + "img/white-check.7591ec7c.svg";